(function() {
    const nav = document.querySelector('.product-tabs') 
        ? document.querySelector('.product-tabs').querySelector('.product-tabs__nav')
        : document.querySelector('.product-tabs__nav');

    function initTabs(navEl) {
        const buttons = navEl.querySelectorAll('.product-tabs__btn');
        const panels = navEl.closest('.product-tabs').querySelectorAll('.product-tabs__panel');

        buttons.forEach(function(btn) {
            btn.addEventListener('click', function() {
                activateTab(btn, buttons, panels);
            });

            btn.addEventListener('keydown', function(event) {
                if (event.key === 'ArrowRight') {
                    const next = btn.nextElementSibling || buttons[0];
                    next.focus();
                    activateTab(next, buttons, panels);
                } else if (event.key === 'ArrowLeft') {
                    const prev = btn.previousElementSibling || buttons[buttons.length - 1];
                    prev.focus();
                    activateTab(prev, buttons, panels);
                }
            });
        });
    }

    function activateTab(activeBtn, buttons, panels) {
        const index = activeBtn.dataset.tab;

        buttons.forEach(function(b) {
            b.classList.remove('active');
            b.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function(p) {
            p.classList.remove('active');
        });

        activeBtn.classList.add('active');
        activeBtn.setAttribute('aria-selected', 'true');

        const panel = document.getElementById('tab-panel-' + index);
        if (panel) panel.classList.add('active');
    }

    document.querySelectorAll('.product-tabs__nav').forEach(initTabs);
})();